//AJAX 프레임
import { ajaxFrame } from '../lib/ajaxForm';
//데이터 API 목록
import { dataUrl } from '../dataUrl';
//쿠키 호출
import { cookies } from '../lib/cookies';

var asideDataId = {};
var asideSubList = {};
var asideKeyData = {};
var advSettingData = {};
var userKey = 'user_id';
//히든값
var groupId = '#advId';
var groupNm = '#advNm';
var groupKey = '#advKey';
var groupSubId = "#adgKey";
var asideClass = '.aside-category';

export const alwaysFunc = {
	init:function() {
		if(cookies.getCookies(userKey) != null) {
			this.asideMenuData(cookies.getCookies(userKey));
			this.headerUserNameData();
		}
	},
	//좌측 매뉴
	asideMenuData:function(obj) {
		var obj = '?user_id=' + obj +  '&status=Active&client_type=premium';
		var dataApi = dataUrl.alwaysAPI('GET', 'leftMenu', obj);
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, alwaysFunc.asideMenuCallBack);
	},
	//좌측 서브 매뉴(즐겨찾기)
	asideMenuSubData:function(obj, callType) {
		var dataApi = dataUrl.alwaysAPI('GET', callType, obj);
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, alwaysFunc.asideMenuSubCallBack);
	},
	//좌측 매뉴 수정(즐겨찾기)
	asideMenuModifyData:function(data) {
		var modifyData = {
			"group" : {
				"id" : data[0],
				"name" : data[1]
			}
		};
		var dataApi = dataUrl.alwaysAPI('PUT', 'menuModify');
		ajaxFrame.ajaxDataCall('PUT', dataApi, 'json', true, alwaysFunc.asideMenuModifyCallBack, modifyData);
	},
	//좌측 매뉴 삭제(즐겨찾기)
	asideMenuDeleteData:function(data) {
		var deleteData = {
			"group" : { "id" : data }
		};
		var dataApi = dataUrl.alwaysAPI('DELETE', 'menuDelete');
		ajaxFrame.ajaxDataCall('DELETE', dataApi, 'json', true, alwaysFunc.asideMenuDeleteCallBack, deleteData);
	},
	//좌측 매뉴 추가(즐겨찾기)
	asideMenuAddData:function(data) {
		var addData = {
			"group" : {
				"name" : data[0],
				"status" : "Active",
				"advs_id" : data[1]
			}
		};
		var dataApi = dataUrl.alwaysAPI('POST', 'menuAdd');
		ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, alwaysFunc.asideMenuAddCallBack, addData);
	},
	//상단 알림창
	headerNewsData:function(obj) {
		var param = '?adv_id=' + obj;
		var dataApi = dataUrl.alwaysAPI('GET', 'news', param);
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, alwaysFunc.headerNewsCallBack);
	},
	//상단 알림 삭제
	headerNewsDeleteData:function(obj) {
		var param = '?rept_job_history_ids=' + obj;
		var dataApi = dataUrl.alwaysAPI('PUT', 'news', param);
		ajaxFrame.ajaxDataCall('PUT', dataApi, 'json', true, alwaysFunc.headerNewsDeleteCallBack);
	},
	//로그인 회원 이름
	headerUserNameData:function() {
		var userName = decodeURIComponent(decodeURIComponent(cookies.getCookies('user_nm')));
		$('#user-name').text(userName);
	},
	//즐겨찾기 사이드 서브 리스트 저장
	favoriteSubListSave:function() {
		return asideSubList;
	},
	//광고주설정 목록
	advSettingPop:function() {
		var obj = '?user_id=' + cookies.getCookies(userKey) + '&status=Active';
		var dataApi = dataUrl.alwaysAPI('GET', 'leftMenu', obj);
		AjaxLoading.pageLoading('time');
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, alwaysFunc.advSettingPopCallBack);
	},
	//광고주설정 저장 기능
	advSettingSaveData:function(thisEl) {
		var thisEl = $(thisEl);
		var preId = '';
		var normalId = '';
		var preStr = 0;
		var normalStr = 0;
		thisEl.find("li input").each(function() {
			var thisCheck = $(this).prop('checked');
			if(thisCheck == true) {
				if(0 == preStr) {
					preId += $(this).parent().data('key');
				}else{
					preId += ',' + $(this).parent().data('key');
				}
				preStr++;
			}else{
				if(0 == normalStr) {
					normalId += $(this).parent().data('key');
				}else{
					normalId += ',' + $(this).parent().data('key');
				}
				normalStr++;
			}
		});
		var obj = '?premium_ids=' + preId + '&normal_ids=' + normalId;
		var dataApi = dataUrl.alwaysAPI('PUT', 'settingUpdate', obj);
		ajaxFrame.ajaxDataCall('PUT', dataApi, 'json', true, alwaysFunc.advSettingSaveCallBack);
	},
	//광고주 설정 검색기능
	advSettingSearchData:function(thisEl) {
		var thisEl = $(thisEl);
		var value = thisEl.val().toUpperCase();
		var advKeyText = Object.keys(advSettingData);
		var uiBox = $('#setting-box-inner');
		if(value == '') {
			uiBox.find('li').show();
		}else{
			for(var i = 0; i < advKeyText.length; i++ ) {
				var keyStr = advKeyText[i].toUpperCase();
				if(String(keyStr).indexOf(value) > -1) {
					uiBox.find('.setting-box-' + advSettingData[advKeyText[i]].id).show();
				}else{
					uiBox.find('.setting-box-' + advSettingData[advKeyText[i]].id).hide();
				}
			}
		}
	},






	//CallBack Functions
	//좌측 매뉴
	asideMenuCallBack:function(data) {
		var path = document.location.hash;
		path = path.replace('#','');
		var dataFilter = data.data;
		var dataKey = Object.keys(dataFilter);
		var asideMenu = '';
		var subPage = true;
		if(0 < dataKey.length) {
			if(path == '/sub/favorite') {
				for (var i = 0; i < dataKey.length; i++) {
					asideMenu += "<li class='cate" + dataFilter[dataKey[i]].id + " deps" + i + " favorite'>";
					asideMenu += 	"<a href='javascript:void(0);' data-id='"+ dataFilter[dataKey[i]].id +"' data-name='" + dataFilter[dataKey[i]].name + "' data-key='" + dataFilter[dataKey[i]].na_customer_ser + "' class='favorite'><span class='menu-name'>"+ dataFilter[dataKey[i]].name +"</span><strong class='allCount'></strong></a>";
					asideMenu += 	"<button type='button' class='group-add-btn hide' data-id='"+ dataFilter[dataKey[i]].id +"'>+</button>";
					asideMenu += 	"<div class='menu-sub-category active'>";
					asideMenu += 		"<ul class='menu-sub-inner'>";
					asideMenu += 		"</ul>";
					asideMenu += 	"</div>";
					asideMenu += "</li>";
					asideMenu += "<li class='create-group-tool hide'>";
					asideMenu += 	"<div class='active-btn-area'>";
					asideMenu += 		"<input type='text' data-id='"+ dataFilter[dataKey[i]].id +"'  value='' class='active-input-area'>";
					asideMenu +=		"<button type='button' class='menu-btn-save' data-id='"+ dataFilter[dataKey[i]].id +"'>저장</button>";
					asideMenu += 		"<button type='button' class='menu-btn-cancer'>취소</button>";
					asideMenu += 	"</div>";
					asideMenu += "</li>";
				}
			}else{
				for (var i = 0; i < dataKey.length; i++) {
					asideMenu += "<li class='cate" + dataFilter[dataKey[i]].id + " deps" + i + "'>";
					asideMenu += 	"<a href='javascript:void(0);' data-id='"+ dataFilter[dataKey[i]].id +"' data-name='" + dataFilter[dataKey[i]].name + "' data-key='" + dataFilter[dataKey[i]].na_customer_ser + "'><span class='menu-name'>"+  dataFilter[dataKey[i]].name +"</span></a>";
					asideMenu += "</li>";
				}
			}
		}else{
			asideMenu += "<li class='no-cate'>";
			asideMenu += 	"<a href='javascript:void(0);' data-id='no-data'>등록된 광고주가 없습니다.</a>";
			asideMenu += "</li>";
		}
		$(asideClass).html(asideMenu);
		alwaysFunc.asideEventCallBack();
	},
	//좌측 서브 매뉴 (즐겨찾기)
	asideMenuSubCallBack:function(data) {
		asideSubList = data.data;
		var dataFilter = asideSubList.groups;
		var subListKey = Object.keys(dataFilter);
		var subListValues = subListKey.map(function(i) {
			return dataFilter[i];
		});
		var hasSubCate = $(asideClass + " .cate" + asideDataId['onId']).find('.menu-sub-category').hasClass('active');
		var asideSubMenu = '';
		if(0 < subListKey.length) {
			for(var i = 0; i < subListKey.length; i++) {
				asideSubMenu += 		"<li class='sub-li " +  subListValues[i].id + "'><a href='javascript:void(0);' data-id='"+ subListValues[i].id +"'>-<span class='group-name'>" + subListValues[i].name + "</span><strong class='subCount'>(" + subListValues[i].count + ")</strong></a>";
				asideSubMenu += 			"<div class='hover-btn-area hide'>";
				asideSubMenu += 				"<button type='button' class='menu-btn-modify' data-id='"+ subListValues[i].id +"'>수정</button>";
				asideSubMenu += 				"<button type='button' class='menu-btn-delete' data-id='"+ subListValues[i].id +"'>삭제</button>";
				asideSubMenu += 			"</div>";
				asideSubMenu += 			"<div class='active-btn-area hide'>";
				asideSubMenu += 				"<input type='text' data-id='"+ subListValues[i].id +"' value='" + subListValues[i].name + "' class='active-input-area'>";
				asideSubMenu +=				"<button type='button' data-id='"+ subListValues[i].id +"' class='menu-btn-save'>저장</button>";
				asideSubMenu += 				"<button type='button' class='menu-btn-cancer'>취소</button>";
				asideSubMenu += 			"</div>";
				asideSubMenu += 		"</li>";
			}
			$(asideClass + " .cate" + asideDataId['onId']).find('.menu-sub-inner').html(asideSubMenu);
			setTimeout(function() {
				$(asideClass + " .cate" + asideDataId['onId'] + ' .menu-sub-category').stop().slideDown(100);
			},100);
		}
		//서브매뉴 콜백 액션
		if(asideSubList.allCount != '' || asideSubList.allCount != null || asideSubList.allCount != 'undefined'){
			$(asideClass + " .cate" + asideDataId['onId']).find('a .allCount').text("(" + asideSubList.allCount + ")");
		}
		alwaysFunc.asideSubEvent();
	},
	//상단 알림창
	headerNewsCallBack:function(data) {
		var dataFilter = data;
		var dataKey = Object.keys(dataFilter);
		var dataValues = dataKey.map(function(key) {
			return dataFilter[key];
		});
		var newsHtml = '';
		var maxLength = 5;
		var newsLength = 0;
		var newsId = '#my-news-data';
		if(0 < dataKey.length) {
			for (var i = 0; i < dataKey.length; i++) {
				if(i < maxLength) {
					newsHtml += "<li class='" + dataKey[i] + "'><div><span>"+ dataFilter[dataKey[i]] +"</span><a class='news-delete' data-key='' onclick='btnActions.newsDeleteBtn(this);' data-number='" + dataKey[i] + "'>X</a></div></li>";
				}
			}
			$('.new-icon').addClass('active');
		}else{
			newsHtml += "<li><p>새로 생성된 데이터가 없습니다.</p></li>";
			$('.new-icon').removeClass('active');
		}
		$(newsId).html(newsHtml);
		$(newsId).find('li').each(function(length) {
			newsLength = length;
		});
	},
	//상단 알림 삭제
	headerNewsDeleteCallBack:function() {
		var createCheck = location.hash;
		var newsLength = null;
		$('#my-news-data').find('li').each(function(length) {
			newsLength = length;
		});
		if(newsLength == null) {
			$('.new-icon').removeClass('active');
		}else{
			$('.new-icon').addClass('active');
		}
	},
	//좌측 매뉴 이벤트
	asideEventCallBack:function() {
		var path = document.location.hash;
		path = path.replace('#','');
		asideDataId['subOnId'] = null;
		if(asideDataId['onId'] == null) {
			//매뉴 광고주 아이디/광고주명/네이버키 저장
			asideDataId['onId'] = $(asideClass + ' li').eq(0).find('a').data('id');
			asideDataId['onNm'] = $(asideClass + ' li').eq(0).find('a').data('name');
			asideDataId['onKey'] = $(asideClass + ' li').eq(0).find('a').data('key');
			$(groupId).val(asideDataId['onId']);
			$(groupNm).val(asideDataId['onNm']);
			$(groupKey).val(asideDataId['onKey']);
			//초기 매뉴 첫번째 엑티브 효과
			$(asideClass + ' li').eq(0).find('a').addClass('active');
		}else{
			$(asideClass + ' li.cate' + asideDataId['onId']).find('a').addClass('active');
		}



		asideDataId['prevId'] = asideDataId['onId'];

		//매뉴 클릭 이벤트
		$(asideClass + ' > li > a').click(function(e) {
			asideDataId['subOnId'] = null;
			//광고주 그룹 아이디 저장
			asideDataId['onId'] = $(this).data('id');
			asideDataId['onNm'] = $(this).data('name');
			asideDataId['onKey'] = $(this).data('key');
			$(groupId).val(asideDataId['onId']);
			$(groupNm).val(asideDataId['onNm']);
			$(groupKey).val(asideDataId['onKey']);

			var subCheck = $(this).next().hasClass('active');
			$('.create-group-tool').hide();

			//좌측매뉴 별 매뉴 데이터 불러오기
			if(asideDataId['onId'] != asideDataId['prevId']){
				if(path == '/sub/favorite') {
					$(asideClass).find('a .allCount').text("");
					$('.menu-sub-category').stop().slideUp(100);
					setTimeout(function() {
						$('.menu-sub-inner').find('li').remove();
						alwaysFunc.asideMenuSubData(asideDataId['onId'], 'subMenu');
					},100);
				}else if(path == '/sub/create' || path == '/index') {
					createFunc.createListCall(asideDataId['onId']);
				}else if(path == '/sub/bidding') {
					biddingFunc.initReptJobHistoryDatesByAdvId(asideDataId['onId']);
				}else if(path == '/sub/setting') {
					settingFunc.callSettingByAdvId(asideDataId['onId']);
				}
				alwaysFunc.headerNewsData(asideDataId['onId']);
				$(asideClass + '> li a').removeClass('active');
				$(this).addClass('active');
				asideDataId['prevId'] = asideDataId['onId'];
				asideDataId['subPrevId'] = "Na";
			}else{
				if(path == '/sub/favorite') {
					$('.menu-sub-category').stop().slideUp(100);
					setTimeout(function() {
						$('.menu-sub-inner').find('li').remove();
					}, 100);
					$(asideClass).find('a .allCount').text("");
					asideDataId['prevId'] = 'Na';
					$(this).removeClass('active');
				}
			}
			//끝

		});
		//좌측 매뉴 생성/삭제/수정 (즐겨찾기)
		$(asideClass + ' > li').mouseenter(function() {
			var $this = $(this);
			$this.find('.group-add-btn').show();
		});
		$(asideClass + ' > li').mouseleave(function() {
			$('.group-add-btn').hide();
		});
		//추가
		$('.group-add-btn').click(function() {
			var $this = $(this);
			var dataId = $this.data('id');
			$this.parent('li').next().show();
			$this.parent('li').next().find('input').attr('data-id', dataId).focus();
		});
		//저장
		$('.create-group-tool').find('.menu-btn-save').click(function() {
			if(confirm('등록하시겠습니까?') == true) {
				var $this = $(this);
				var saveText = $this.parent().find('input').val();
				var saveGroupId = $this.data('id');
				var addSave = [saveText,saveGroupId];
				//데이터 넣는곳 필요
				if(saveText == '') {
					alert('입력 값이 없습니다.');
				}else{
					alwaysFunc.asideMenuAddData(addSave);
				}
			}else{
				return;
			}
		});
		$('.create-group-tool').find('.active-input-area').keydown(function(e) {
			if (e.which == 13){
				if(confirm('등록하시겠습니까?') == true) {
					var $this = $(this);
					var saveText = $this.parent().find('input').val();
					var saveGroupId = $this.data('id');
					var addSave = [saveText,saveGroupId];
					//데이터 넣는곳 필요
					if(saveText == '') {
						alert('입력 값이 없습니다.');
					}else{
						alwaysFunc.asideMenuAddData(addSave);
					}
				}else{
					return;
				}
			}
		});
		//취소
		$('.create-group-tool').find('.menu-btn-cancer').click(function() {
			$(this).parents('.create-group-tool').hide();
		});


		//좌측매뉴 불러오기
		if(asideDataId['onId'] == 'no-data' || asideDataId['onId'] == '') {
			$('#bidding-area, #create-area, #favorite-area, #setting-area').hide();
			$('.no-data-wrap').show();
		}else{
			$('#bidding-area, #create-area, #favorite-area, #setting-area').show();
			$('.no-data-wrap').hide();
			if(path == '/sub/favorite') {
				alwaysFunc.asideMenuSubData(asideDataId['onId'], 'subMenu');
			}else if((path == '/sub/create' || path == '/index') && asideDataId['onId'] != 'no-data') {
				createFunc.createListCall(asideDataId['onId']);
			}else if(path == '/sub/bidding' && asideDataId['onId'] != 'no-data') {
				biddingFunc.initReptJobHistoryDatesByAdvId(asideDataId['onId']);
			}else if(path == '/sub/setting' && asideDataId['onId'] != 'no-data') {
				settingFunc.callSettingByAdvId(asideDataId['onId']);
			}
			alwaysFunc.headerNewsData(asideDataId['onId']);
		}
	},
	//좌측 서브 매뉴 이벤트(즐겨찾기)
	asideSubEvent:function() {
		var subEl = '.menu-sub-inner li.sub-li';
		if(asideDataId['subOnId'] == null) {
			asideDataId['subOnId'] = $(subEl).eq(0).find('a').data('id');
			$(groupSubId).val(asideDataId['subOnId']);
			$(subEl).eq(0).find('a').addClass('active');
			favoriteFunc.favoriteSubListData(asideDataId['subOnId']);
		}
		//즐겨찾기 매뉴 서브 데이터
		$(subEl).find('a').click(function() {
			asideDataId['subOnId'] = $(this).data('id');
			var thisHas = $(this).hasClass('active');
			if(asideDataId['subOnId'] != asideDataId['subPrevId']){
				$(groupSubId).val(asideDataId['subOnId']);
				favoriteFunc.favoriteSubListData(asideDataId['subOnId']);
				$('.menu-sub-inner li a').removeClass('active');
				$(this).addClass('active');
				asideDataId['subPrevId'] = asideDataId['subOnId'];
			}
		});
		//좌측 서브 매뉴 생성/삭제/수정 (즐겨찾기)
		$(subEl).mouseover(function() {
			var $this = $(this);
			$(subEl).find('.hover-btn-area').hide();
			$this.find('.hover-btn-area').show();
		});
		$(subEl).mouseleave(function() {
			$(subEl).find('.hover-btn-area').hide();
		});
		//수정
		$(subEl).find('.menu-btn-modify').click(function() {
			var $this = $(this);
			var thisId = $this.parent().prev().data('id');
			$(subEl).find('.active-btn-area').hide();
			$this.parent('.hover-btn-area').next('.active-btn-area').show().find('input').focus();
		});
		//취소
		$(subEl).find('.menu-btn-cancer').click(function() {
			$(subEl).find('.active-btn-area').hide();
		});
		//ESC 버튼 취소
		$(document).keyup(function(e) {
			if (e.keyCode == 27) {
				$(subEl).find('.active-btn-area').hide();
				$('.create-group-tool').hide();
			}
		});
		//저장
		$(subEl).find('.menu-btn-save').bind('click',function(e) {
			if(confirm('저장하시겠습니까?') == true) {
				var $this = $(this);
				var saveText = $this.parent().find('.active-input-area').val();
				var saveId = $this.data('id');
				var modifySave = [saveId, saveText];
				if(saveText == '') {
					alert('입력 값이 없습니다.');
				}else{
					alwaysFunc.asideMenuModifyData(modifySave);
					$this.parent().parent('li').find('.group-name').text(saveText);
					$this.parent().hide();
				}
			}else{
				return;
			}
		});
		$(subEl).find('.active-input-area').bind('keydown',function(e) {
			if (e.which == 13){
				if(confirm('저장하시겠습니까?') == true) {
					var $this = $(this);
					var saveText = $this.parent().find('.active-input-area').val();
					var saveId = $this.data('id');
					var modifySave = [saveId, saveText];
					if(saveText == '') {
						alert('입력 값이 없습니다.');
					}else{
						alwaysFunc.asideMenuModifyData(modifySave);
						$this.parent().parent('li').find('.group-name').text(saveText);
						$this.parent().hide();
					}
				}else{
					return;
				}
			}
		});
		//삭제
		$(subEl).find('.menu-btn-delete').click(function() {
			var $this = $(this);
			var deleteId = $this.data('id');
			if(confirm('삭제하시겠습니까?') == true) {
				$this.parent().parent('li').remove();
				alwaysFunc.asideMenuDeleteData(deleteId);
			}
		});

	},
	advSettingPopCallBack:function(data) {
		var dataFilter = data.data;
		var dataKey = Object.keys(dataFilter);
		var temp_obj = {};
		var html = "";
		if(0 < dataKey.length) {
			dataKey.map(function(key) {
				temp_obj[dataFilter[key].name] = dataFilter[key];
			});
			advSettingData = temp_obj;
			var newDataKey = Object.keys(temp_obj);
			newDataKey.sort();
			for(var i = 0; i < newDataKey.length; i++) {
				html += "<li class='setting-box-" + temp_obj[newDataKey[i]].id + "' data-key='" + temp_obj[newDataKey[i]].id + "'>";
				if(temp_obj[newDataKey[i]].client_type == 'premium') {
					html += "<input id='set-box-" + i +"' type='checkbox' checked value=''>";
				}else{
					html += "<input id='set-box-" + i +"' type='checkbox' value=''>";
				}
				html += 	"<label for='set-box-" + i + "'>" + temp_obj[newDataKey[i]].name + "</label>";
				html += "</li>";
			}
		}else{
			html += "<li class='no-data-message'>";
			html += 	"<div class='no-data'>";
			html += 		"* 광고주 목록이 없습니다. 원더박스에서 확인 후 이용해주세요.";
			html += 	"</div>";
			html += "</li>";
		}
		$('#setting-box-inner').html(html);
		$('.fixed-pop').fadeIn(200);
		$('#timeLoading').remove();
	},
	//좌측 광고주 추가 (즐겨찾기)
	asideMenuAddCallBack:function() {
		alwaysFunc.asideMenuData(cookies.getCookies(userKey));
	},
	advSettingSaveCallBack:function(data) {
		delete asideDataId['onId'];
		alwaysFunc.asideMenuData(cookies.getCookies(userKey));
		layerPopup.close();
	},
	//좌측 매뉴 수정(즐겨찾기)
	asideMenuModifyCallBack:function() {
	},
	asideMenuDeleteCallBack:function() {
	}
}

window.alwaysFunc = alwaysFunc;



// WEBPACK FOOTER //
// ./js/controller/assets/layout/loadData.js